import GetApiKeys from '@/graphql/GetApiKeys.gql'
import CreateApiKey from '@/graphql/CreateApiKey.gql'
import { createProvider } from '@/vue-apollo'

const apollo = createProvider()

export default {
  async getApiKeys ({ commit, dispatch }) {
    try {
      const { data } = await apollo.defaultClient.query({
        query: GetApiKeys,
        fetchPolicy: 'no-cache'
      })
      return data.getApiKeys
    } catch (error) {
      dispatch('showError', error)
    }
  },
  async createApiKey ({ commit, dispatch }) {
    try {
      const { data } = await apollo.defaultClient.query({
        query: CreateApiKey,
        fetchPolicy: 'no-cache'
      })
      dispatch('addTemporalNotification', { type: 'success', message: 'La API Key se ha creado correctamente' })
      return data.createApiKey
    } catch (error) {
      dispatch('showError', error)
    }
  }
}
